import { RelativeUrl } from "@adora/shared/utils/environment";
import fetcher from "@adora/shared/utils/fetch";
import patch from "@adora/shared/utils/patch";
import { PresignedPostDestinationPath } from "@adora/shared/types/presigned-post";

function getPresignedPost(brandId: string) {
  return fetcher<PresignedPostDestinationPath>(`${RelativeUrl}/ad_asset_images/upload_url`, {
    brand_id: brandId
  });
}

export default async function uploadAdAssetImage(file: File, brandId: string, imageId: number) {
  const { presigned_post: presignedPost, destination_path } = await getPresignedPost(brandId);

  const formData = new FormData();
  Object.keys(presignedPost.fields).forEach((key) => {
    formData.append(key, presignedPost.fields[key]);
  });

  formData.append("file", file, file.name);

  const uploadRequestOptions = {
    method: "POST",
    body: formData
  };

  const response = await fetch(presignedPost.url, uploadRequestOptions);
  if (response.status > 204) {
    throw "Invalid response from the server. Expected 200 status code.";
  }

  const newPath = `${destination_path}/${file.name}`;

  return await patch(
    `${RelativeUrl}/ad_asset_images/${imageId}`,
    {
      brand_id: String(brandId)
    },
    {
      file_path: newPath
    }
  );
}
